
define( 'FORCES_AND_MOTION_BASICS/../nls/nl/forces-and-motion-basics-strings',{
          "none": "geen",
          "force": "kracht",
          "values": "waarden",
          "frictionTitle": "wrijving",
          "redWins": "Rood wint!",
          "frictionForce": "wrijvingskracht",
          "pause": "Pauze",
          "friction": "Wrijving",
          "accelerationLab": "Versnelling",
          "forces-and-motion-basics.name": "Kracht en beweging: basis",
          "appliedForce": "aangewende kracht",
          "leftForce": "Kracht naar links",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Kracht naar rechts",
          "acceleration": "versnelling",
          "sound": "geluid",
          "lots": "veel",
          "forces": "krachten",
          "motion": "Beweging",
          "tugOfWar": "Touwtrekken",
          "go": "Start!",
          "newtons.n": "Newton (N)",
          "sumOfForcesEqualsZero": "som van de krachten = 0",
          "blueWins": "Blauw wint!",
          "speed": "snelheid",
          "sumOfForces": "som van de krachten",
          "return": "Opnieuw",
          "translation.credits": "Koen Pieters",
          "newtons": "Newton",
          "masses": "massa's",
          "forceReadout.pattern": "{0} N"
        } );